export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-gray-50">
      <div className="container py-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Andelsexperten</h3>
            <p className="text-sm text-gray-600">
              Your trusted partner for housing cooperative expertise.
            </p>
          </div>
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Quick Links</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <a href="/" className="hover:text-primary-600">
                  Home
                </a>
              </li>
              <li>
                <a href="/about" className="hover:text-primary-600">
                  About
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-primary-600">
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="mb-4 text-lg font-semibold text-gray-900">Legal</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>
                <a href="/privacy" className="hover:text-primary-600">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-primary-600">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-200 pt-8 text-center text-sm text-gray-600">
          <p>&copy; {currentYear} Andelsexperten. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
